(function ($, window) {
  const mobileWidth = 749;
  const phoneWidth = 479;

  let windowWidth = window.innerWidth;

  function setWindowWidth() {
    if (windowWidth !== window.innerWidth) {
      windowWidth = window.innerWidth;
    }
  }

  function isMobile() {
    return window.innerWidth <= mobileWidth;
  }

  function isPhone() {
    return window.innerWidth <= phoneWidth;
  }

  function isTablet() {
    return isMobile() && !isPhone();
  }

  function isHorizontalResize() {
    return windowWidth !== window.innerWidth;
  }

  function isMobileToDesktopResize() {
    return isHorizontalResize() && windowWidth <= mobileWidth && window.innerWidth > mobileWidth;
  }

  function isDesktopToMobileResize() {
    return isHorizontalResize() && windowWidth > mobileWidth && window.innerWidth <= mobileWidth;
  }

  function isTabletToPhoneResize() {
    return isHorizontalResize() && windowWidth > phoneWidth && window.innerWidth <= phoneWidth;
  }

  function isPhoneToTabletResize() {
    return isHorizontalResize() && windowWidth <= phoneWidth && window.innerWidth > phoneWidth;
  }

  function isDesktopMobileSwitch() {
    return isDesktopToMobileResize() || isMobileToDesktopResize();
  }

  function isTabletPhoneSwitch() {
    return isTabletToPhoneResize() || isPhoneToTabletResize();
  }

  window.windowSizeHelper = {
    setWindowWidth,
    isMobile,
    isPhone,
    isTablet,
    isHorizontalResize,
    isMobileToDesktopResize,
    isDesktopToMobileResize,
    isTabletToPhoneResize,
    isPhoneToTabletResize,
    isDesktopMobileSwitch,
    isTabletPhoneSwitch,
  };
}(jQuery, window));
